module.exports = __webpack_public_path__ + "static/media/radius01.04f7483e.PNG";